<!-- Revised on 2024/11/26 by mnavarro -->
<template>
  <div class="col-lg-4 col-md-6 col-12 dataTable-info">
    <div v-if="total != 0" class="dataTable-info">
      {{ $t('key_pager_information_showing_records') }} {{ (current - 1)* rows +1 }} {{ $t('key_pager_information_to') }} {{ endRow }} {{ $t('key_pager_information_of') }} {{ total }} {{ $t('key_pager_information_records') }}
    </div>
  </div>
</template>

<script>

  export default {
    name: "PagerInformation",
    props: {
      total:{
        type: Number,
        default: 0
      },
      current: {
        type: Number,
        default: 0
      },
      rows:{
        type:Number,
        default: 0
      }
    },
    computed: {
      endRow() {
        let totalPages = Math.ceil(this.total / this.rows);
        return totalPages === this.current ? this.total : this.current * this.rows;
      }
    }
  };

</script>